module.exports = __webpack_public_path__ + "static/media/SF-12-A (1).f98425c0.mp3";